import { useQuery } from "@tanstack/react-query";
import { useAuthToken } from "../useAuthToken";
import {
  getAvailabilitiesForProgram,
  getConsultAvailabilities,
} from "../../services/steadymdService";

export const useConsultAvailabilitiesQuery = (
  consultId: string | undefined
) => {
  const token = useAuthToken();

  return useQuery({
    queryKey: ["steadymd", "availability", consultId],
    queryFn: () => getConsultAvailabilities(consultId ?? "", token ?? ""),
    enabled: !!token && !!consultId,
    staleTime: 5 * 60 * 1000, // 5 minutes - availability slots don't change frequently
  });
};

export const useProgramAvailabilitiesQuery = (
  usState: string,
  consultType: string,
  isAsync: boolean
) => {
  const token = useAuthToken();

  return useQuery({
    queryKey: [
      "steadymd",
      "program-availability",
      { usState, consultType, isAsync },
    ],
    queryFn: () =>
      getAvailabilitiesForProgram(usState, consultType, isAsync, token ?? ""),
    enabled: !!token && !!usState && !!consultType,
    staleTime: 5 * 60 * 1000, // 5 minutes - availability slots don't change frequently
  });
};
